export const shrinkIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}</style></defs><path d="m15.5 8.499 8-8m-23 23 8-8m12-7h-5v-5m-7 17v-5h-5m12 0 8 8m-23-23 8 8m7 12v-5h5m-17-7h5v-5" class="a"/><circle cx="12" cy="11.999" r="2" class="a"/></svg>`,
    name: 'shrink'
};